import { Helmet } from 'react-helmet-async'
import { useTranslation } from 'react-i18next'
import SuiteInfo from '@/features/Listing/suite-info'
import TenantPaymentHistory from '@/features/Payments/tenant-payment-history'
import MakePayment from './make-payment'
import PadPaymentRequest from './pad-payment-request'
import usePayment from './use-payment'

const Payment = ({
  match: {
    params: { listingId, paymentId }
  },
  history
}) => {
  const { t } = useTranslation()
  const paymentData = usePayment({ paymentId, listingId })
  if (!paymentData) return null
  const isPending = paymentData.state_machine === 'pending'
  const isPad = paymentData.request_type === 'pad'
  return (
    <>
      <Helmet>
        <title>{t('b.payments.view.payments.title', 'Payments')}</title>
      </Helmet>
      <SuiteInfo listingId={listingId} />
      {isPending ? (
        <>
          {isPad ? (
            <PadPaymentRequest
              paymentData={paymentData}
              listingId={listingId}
              paymentId={paymentId}
            />
          ) : (
            <MakePayment paymentData={paymentData} history={history} />
          )}
        </>
      ) : (
        <TenantPaymentHistory paymentData={paymentData} history={history} />
      )}
    </>
  )
}

export default Payment
